import React from 'react';
import { makeAutoObservable } from 'mobx';
import _ from 'lodash';

class HorizontalScrollState {
  element;
  scrolling;
  fixedArrows;

  top;

  constructor() {
    makeAutoObservable(this);
  }

  receiveProps({fixedArrows}) {
    this.fixedArrows = fixedArrows;
  }

  mount() {
    this.element = React.createRef();
  }

  scrollPosition(e) {
    const rect = e.target.getBoundingClientRect();
    this.top = e.clientY - rect.top - 30;
  }

  scrollRight(e) {
    e.preventDefault();
    const element = this.element.current;
    const scrolling = setInterval(function() {
      element.scrollLeft += 15;
    }, 26);

    this.scrolling = scrolling;
  }

  scrollLeft(e) {
    e.preventDefault();
    const element = this.element.current;
    const scrolling = setInterval(function() {
      element.scrollLeft -= 15;
    }, 26);

    this.scrolling = scrolling;
  }

  clearScrolling() {
    clearInterval(this.scrolling);
  }

  get showScrollBars() {
    if (!_.get(this.element, 'current')) return false;
    return this.element.current.scrollWidth > this.element.current.clientWidth;
  }
}

export default HorizontalScrollState;
